import { render, staticRenderFns } from "./AssetDetail.vue?vue&type=template&id=7922d532&"
import script from "./AssetDetail.vue?vue&type=script&lang=ts&"
export * from "./AssetDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports